import initProjectPipelinesChartsApp from '~/projects/pipelines/charts/index';

initProjectPipelinesChartsApp();
